/**
 * Full-page error UI, rendered by the root route's ErrorBoundary (src/root.jsx).
 */
export function ErrorFallback({ error, onReset = () => window.location.reload() }) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            textAlign: 'center',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '16px',
                padding: '2rem',
                maxWidth: '500px',
                backdropFilter: 'blur(10px)',
            }}>
                <h1 style={{ fontSize: '3rem', margin: '0 0 1rem 0' }}>😵</h1>
                <h2 style={{ margin: '0 0 1rem 0' }}>Oops! Something went wrong</h2>
                <p style={{ marginBottom: '2rem', opacity: 0.9 }}>
                    The app encountered an unexpected error. Don't worry, you can try refreshing the page.
                </p>
                {import.meta.env.MODE === 'development' && error && (
                    <details style={{
                        marginBottom: '1rem',
                        textAlign: 'left',
                        background: 'rgba(0, 0, 0, 0.2)',
                        padding: '1rem',
                        borderRadius: '8px',
                        fontSize: '0.875rem',
                    }}>
                        <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>
                            Error Details (Development Only)
                        </summary>
                        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            {error.toString()}
                        </pre>
                    </details>
                )}
                <button
                    onClick={onReset}
                    style={{
                        background: 'white',
                        color: '#667eea',
                        border: 'none',
                        padding: '0.75rem 2rem',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                >
                    Refresh Page
                </button>
            </div>
        </div>
    );
}

export default ErrorFallback;
